import React, { useState } from 'react';
import { Link, Box, Typography, Container, Button } from '@mui/material';
import Phone from '@mui/icons-material/Phone';
import Language from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Temp1 from '../assets/images/client3.png';
import Temp2 from '../assets/images/client1.jpg';
import Temp3 from '../assets/images/client2.jpg';
import Temp4 from '../assets/images/client4.png';
import { Fade } from "react-awesome-reveal";

function Cards() {
    const [hoveredCard, setHoveredCard] = useState(null);

    const restaurants = [
        {
            name: "Korean BBQ Edinburgh",
            image: Temp1,
            phone: "+44 131 357 6000",
            location: "Edinburgh",
            description: "Where small and shared plates take center stage. Immerse yourself in the art of Korean BBQ with our built-in table grills.",
            website: "https://koreanbbq.kjgroups.co.uk",
        },
        {
            name: "Korean BBQ Dundee",
            image: Temp4,
            phone: "+44 138 252 1144",
            location: "Dundee",
            description: "Experience authentic Korean BBQ in Dundee. Premium meats, traditional sides, and interactive dining experience.",
            website: "https://koreanbbqdundee.kjgroups.co.uk/",
        },
        {
            name: "Korean Munchies",
            image: Temp2,
            phone: "+44 131 285 3038",
            location: "Edinburgh",
            description: "The first Korean Street Food Space in the city, offering an easy-going environment for authentic Korean delights.",
            website: "https://koreanmunchies.kjgroups.co.uk/",
        },
        {
            name: "Soul Sushi",
            image: Temp3,
            phone: "+44 131 667 0200",
            location: "Edinburgh",
            description: "Fresh rolls, nigiri, sashimi, poké bowls & hot katsu curries with great student deals and amazing atmosphere.",
            website: "https://soulsushi.kjgroups.co.uk/",
        },
    ];

    return (
        <Box
            className="restaurants-section"
            sx={{
                background: 'linear-gradient(180deg, rgba(10,10,10,1) 0%, rgba(20,20,20,1) 50%, rgba(10,10,10,1) 100%)',
                py: { xs: 8, md: 12 },
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '1px',
                    background: 'linear-gradient(90deg, transparent, rgba(255,77,77,0.3), rgba(249,203,40,0.3), transparent)'
                }
            }}
        >
            <Container maxWidth="xl">
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
                    <Fade direction="down" triggerOnce duration={1000}>
                        <Box sx={{
                            width: { xs: '60px', md: '80px' },
                            height: '4px',
                            background: 'linear-gradient(90deg, #FF4D4D, #F9CB28)',
                            margin: '0 auto 2rem',
                            borderRadius: '2px'
                        }} />
                        <Typography
                            variant="h2"
                            sx={{
                                fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
                                fontWeight: 800,
                                background: 'linear-gradient(135deg, #FF4D4D, #F9CB28)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                marginBottom: 2,
                                textTransform: 'uppercase',
                                letterSpacing: '2px'
                            }}
                        >
                            Our Restaurants
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.2rem' },
                                color: 'rgba(255,255,255,0.7)',
                                maxWidth: '600px',
                                margin: '0 auto'
                            }}
                        >
                            Authentic Asian Cuisine in Scotland
                        </Typography>
                    </Fade>
                </Box>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            lg: 'repeat(4, 1fr)'
                        },
                        gap: { xs: 3, md: 4 },
                        position: 'relative'
                    }}
                >
                    {restaurants.map((restaurant, index) => (
                        <Fade
                            key={index}
                            direction="up"
                            delay={index * 100}
                            triggerOnce
                            duration={1000}
                        >
                            <Box
                                onMouseEnter={() => setHoveredCard(index)}
                                onMouseLeave={() => setHoveredCard(null)}
                                sx={{
                                    position: 'relative',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    background: 'rgba(255,255,255,0.03)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    transform: hoveredCard === index ? 'translateY(-10px)' : 'translateY(0)',
                                    boxShadow: hoveredCard === index
                                        ? '0 20px 60px rgba(255, 77, 77, 0.3)'
                                        : '0 10px 30px rgba(0,0,0,0.3)',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: hoveredCard === index
                                            ? 'linear-gradient(135deg, rgba(255,77,77,0.1), rgba(249,203,40,0.1))'
                                            : 'transparent',
                                        transition: 'all 0.4s ease',
                                        zIndex: 0
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'relative',
                                        height: '250px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={restaurant.image}
                                        alt={restaurant.name}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.4s ease',
                                            transform: hoveredCard === index ? 'scale(1.1)' : 'scale(1)'
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: 'linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.8) 100%)'
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 16,
                                            right: 16,
                                            background: 'linear-gradient(135deg, #FF4D4D, #F9CB28)',
                                            padding: '8px 16px',
                                            borderRadius: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.5
                                        }}
                                    >
                                        <LocationOnIcon sx={{ fontSize: '1rem', color: '#fff' }} />
                                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, color: '#fff' }}>
                                            {restaurant.location}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ p: 3, position: 'relative', zIndex: 1 }}>
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: '1.4rem',
                                            fontWeight: 700,
                                            color: '#fff',
                                            mb: 2,
                                            lineHeight: 1.2
                                        }}
                                    >
                                        {restaurant.name}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: '0.95rem',
                                            color: 'rgba(255,255,255,0.7)',
                                            mb: 3,
                                            lineHeight: 1.6,
                                            minHeight: '80px'
                                        }}
                                    >
                                        {restaurant.description}
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1.5
                                        }}
                                    >
                                        <Button
                                            component={Link}
                                            href={restaurant.website}
                                            target="_blank"
                                            sx={{
                                                background: 'linear-gradient(135deg, #FF4D4D, #F9CB28)',
                                                color: '#fff',
                                                padding: '10px 20px',
                                                borderRadius: '12px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.95rem',
                                                transition: 'all 0.3s ease',
                                                display: 'flex',
                                                gap: 1,
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #F9CB28, #FF4D4D)',
                                                    transform: 'translateX(5px)'
                                                }
                                            }}
                                        >
                                            <Language sx={{ fontSize: '1.2rem' }} />
                                            Visit Website
                                        </Button>

                                        <Button
                                            component={Link}
                                            href={`tel:${restaurant.phone}`}
                                            sx={{
                                                background: 'rgba(255,255,255,0.1)',
                                                color: '#fff',
                                                padding: '10px 20px',
                                                borderRadius: '12px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.95rem',
                                                border: '1px solid rgba(255,255,255,0.2)',
                                                transition: 'all 0.3s ease',
                                                display: 'flex',
                                                gap: 1,
                                                '&:hover': {
                                                    background: 'rgba(255,255,255,0.15)',
                                                    borderColor: '#FF4D4D'
                                                }
                                            }}
                                        >
                                            <Phone sx={{ fontSize: '1.2rem' }} />
                                            {restaurant.phone}
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Fade>
                    ))}
                </Box>
            </Container>
        </Box>
    );
}

export default Cards;
